import React, { useState, useEffect, useRef } from "react";
import { UploadedImageInfo, useS3Uploader } from "../../../hooks/useS3Uploader";
import "../../../center admin css/OralImagingForm.css";

interface ImageUploadBoxProps {
  emrId: string;
  moduleName: string;
  label: string;
  // onUploaded: (keys: string[]) => void; // ✅ KEYS
  onUploaded: (images: UploadedImageInfo[]) => void;
  resetTrigger: number;
}

const ImageUploadBox: React.FC<ImageUploadBoxProps> = ({
  emrId,
  moduleName,
  label,
  onUploaded,
  resetTrigger,
}) => {
  const { uploading, progress, uploadImage } = useS3Uploader(emrId);
  // const [previewUrls, setPreviewUrls] = useState<string[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // setPreviewUrls([]);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [resetTrigger]);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;
    console.log("Selected Files Count =", files.length);
    console.log(
      "Selected Files =",
      Array.from(files).map((f) => f.name),
    );

    // const uploadedKeys: string[] = [];
    const uploadedImages: UploadedImageInfo[] = [];
    // const previews: string[] = [];

    for (const file of Array.from(files)) {
      const result = await uploadImage(file, moduleName);
      console.log("Uploading:", file.name);
      console.log("Upload Result:", result);
      if (result) {
        // uploadedKeys.push(result.key); // ✅ STORE KEY
        uploadedImages.push(result);
        // if (result.previewUrl) previews.push(result.previewUrl);
      }
    }

    // setPreviewUrls((prev) => [...prev, ...previews]);
    console.log("Final uploadedImages =", uploadedImages);
    // onUploaded(uploadedKeys); // ✅ SEND KEYS
    onUploaded(uploadedImages); // ✅ SEND IMAGES
  };

  return (
    <div style={{ border: "2px dashed #00a8a8", padding: 16 }}>
      <h4>{label}</h4>

      {/* {previewUrls.length > 0 && (
        <div style={{ display: "flex", gap: 8 }}>
          {previewUrls.map((url, i) => (
            <img key={i} src={url} width={120} />
          ))}
        </div>
      )} */}

      {/* <input
        ref={fileInputRef}
        className="oral-file-input"
        type="file"
        multiple
        accept="image/*"
        onChange={handleFileChange}
      /> */}

      <button
        type="button"
        className="oral-upload-trigger"
        onClick={() => fileInputRef.current?.click()}
      >
        Upload Images
      </button>

      <input
        ref={fileInputRef}
        className="oral-file-input"
        type="file"
        multiple
        accept="image/*"
        onChange={handleFileChange}
      />

      {uploading && <p>Uploading… {progress}%</p>}
    </div>
  );
};

export default ImageUploadBox;
